import axios from 'axios';
import FormData from 'form-data';
import { API } from '@config/common';

export const getUserPlaylists = () => {
  return axios({
    method: 'get',
    url: API.PLAYLIST,
    headers: { authorization: sessionStorage.getItem('accessToken') },
  });
};

export const fetchedPlayListContents = (playlistId) => {
  return axios({
    method: 'get',
    url: `${API.PLAYLIST}${playlistId}/content`,
    headers: { authorization: sessionStorage.getItem('accessToken') },
  });
};

export const fetchedHQPlayListContents = () => {
  return axios({
    method: 'get',
    url: API.PLAYLIST_CONTENTS_HQ,
    headers: { authorization: sessionStorage.getItem('accessToken') },
  });
};

export const deletePlayList = (playlistId) => {
  return axios({
    method: 'delete',
    url: `${API.PLAYLIST}/${playlistId}`,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    params: { id: playlistId },
  });
};

export const editPLayList = (playlistId, playlistName, colorHex) => {
  return axios({
    method: 'put',
    url: `${API.PLAYLIST}/${playlistId}`,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'application/json',
    },
    data: JSON.stringify({
      name: playlistName,
      color_hex: colorHex,
    }),
  });
};

export const editPLayListContentName = (payload) => {
  return axios({
    method: 'put',
    url: `${API.CONTENTS}${payload.playlist_id}`,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'application/json',
    },
    data: JSON.stringify({
      id: payload.playlist_id,
      title: payload.playlist_name,
    }),
  });
};

export const addPlayList = (playlistName, colorHex, userId) => {
  return axios({
    method: 'post',
    url: API.PLAYLIST,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'application/json',
    },
    params: { user_id: userId },
    data: JSON.stringify({
      name: playlistName,
      color_hex: colorHex,
    }),
  });
};

export const deletePlayListContents = (playlistId, contentId) => {
  return axios({
    method: 'delete',
    url: `${API.PLAYLIST}/${playlistId}/content/${contentId}`,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    params: { id: playlistId, content_id: contentId },
  });
};

export const addPlayListContent = (fileData) => {
  const formData = new FormData();
  formData.append('request_id', fileData.request_id);
  formData.append('file_id', fileData.file_id);
  formData.append('file', fileData.file, fileData.file.name);
  return axios({
    method: 'post',
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': `multipart/form-data; boundary=${
        // eslint-disable-next-line no-underscore-dangle
        (formData as any)._boundary
      }`,
    },
    url: `${API.PLAYLIST}${fileData.playlist_id}/content`,
    data: formData,
  });
};

export const addPlayListApi = (apiData) => {
  return axios({
    method: 'post',
    url: `${API.PLAYLIST}${apiData.playlist_id}/forecasts`,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'application/json',
    },
    data: { request_id: apiData.request_id, forecasts: apiData.forecasts },
  });
};

export const addPlayListClocks = (apiData) => {
  return axios({
    method: 'post',
    url: `${API.PLAYLIST}${apiData.playlist_id}/clock`,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'application/json',
    },
    data: { request_id: apiData.request_id, clocks: apiData.clocks },
  });
};

export const addPlayListNews = (apiData) => {
  return axios({
    method: 'post',
    url: `${API.PLAYLIST}${apiData.playlist_id}/news`,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'application/json',
    },
    params: { id: apiData.playlist_id },
    data: {
      request_id: apiData.request_id,
      country_code: apiData.country_code,
      news: apiData.news,
    },
  });
};

export const updatePlayListContent = (payload) => {
  return axios({
    method: 'put',
    url: `${API.PLAYLIST}${payload.playlist_id}/content`,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'application/json',
    },
    data: JSON.stringify(payload),
  });
};

export const contentsThumbnail = (contentId) => {
  return axios({
    method: 'get',
    url: `${API.API_CONTENTS}${contentId}/thumbnail`,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    data: null,
    responseType: 'arraybuffer',
  });
};

export const contentsPreview = (contentId) => {
  return axios({
    method: 'get',
    url: `${API.API_CONTENTS}${contentId}/preview`,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    data: null,
    responseType: 'arraybuffer',
  });
};

export const accuLocation = (query) => {
  return axios({
    method: 'get',
    url: API.API_ACCU_LOCATION,
    // Test
    // url: `${API.API_ACCU_LOCATION}?apikey=vQkblBJPoovslfRfdF2TpLaQtCJAyJm1&q=%EC%8B%A0%EC%84%9D%EB%A6%AC&language=ko-kr`,
    params: query,
  });
};

export const weatherTheme = (countryCode) => {
  return axios({
    method: 'get',
    url: API.API_WEATHER,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    params: { country_code: countryCode },
  });
};

export const weatherThumbnail = (payload) => {
  return axios({
    method: 'get',
    url: `${API.API_WEATHER}/${payload.id}/thumbnail`,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    params: { country_code: payload.country_code },
    responseType: 'arraybuffer',
  });
};

export const finedustTheme = () => {
  return axios({
    method: 'get',
    url: API.API_FINEDUST,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    data: null,
  });
};

export const finedustThumbnail = (id) => {
  return axios({
    method: 'get',
    url: `${API.API_FINEDUST}/${id}/thumbnail`,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    data: null,
    responseType: 'arraybuffer',
  });
};

export const ultrafinedustTheme = () => {
  return axios({
    method: 'get',
    url: API.API_ULTRAFINEDUST,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    data: null,
  });
};

export const ultrafinedustThumbnail = (id) => {
  return axios({
    method: 'get',
    url: `${API.API_ULTRAFINEDUST}/${id}/thumbnail`,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    data: null,
    responseType: 'arraybuffer',
  });
};

export const newsTheme = (countryCode) => {
  return axios({
    method: 'get',
    url: API.API_NEWS,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    params: { country_code: countryCode },
  });
};

export const newsThumbnail = (payload) => {
  return axios({
    method: 'get',
    url: `${API.API_NEWS}/${payload.id}/thumbnail`,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    params: { id: payload.id, country_code: payload.country_code },
    responseType: 'arraybuffer',
  });
};

export const clocksTheme = (countryCode) => {
  return axios({
    method: 'get',
    url: API.API_CLOCKS,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    params: { country_code: countryCode },
    data: null,
  });
};

export const clocksThumbnail = (id) => {
  return axios({
    method: 'get',
    url: `${API.API_CLOCKS}/${id}/thumbnail`,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    data: null,
    responseType: 'arraybuffer',
  });
};
